import {FC, PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'
import SearchContainer from './SearchContainer'

type PropType = FC<PropsWithChildren<{
    simple?: boolean
    className?: string
    type?: 'product' | 'dca'
    filterFlag?: boolean
}>>

const Search: PropType = ({simple, className, filterFlag}) => {
    const location = useLocation()
    let searchComponent;

    // 根据 location.pathname 的值来决定显示哪个组件
    switch (location.pathname) {
        case '/dca':
            searchComponent = <SearchContainer key="dca" simple={simple} className={className} type='dca' filterFlag={filterFlag} />;
            break;
        case '/sdcp':
            searchComponent = <SearchContainer key="sdcp" simple={simple} className={className} type='sdcp' filterFlag={filterFlag} />;
            break;
        default:
            searchComponent = <SearchContainer key="other" simple={simple} className={className} type='product' filterFlag={filterFlag} />;
            break;
    }
    return (
        searchComponent
    )
}

export default Search
